import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import pageModel from "../../models/pages.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: pagesData, mutate: reloadPageData, isLoading } = useSWR(
        queryParams || null,
        () => pageModel.list(queryParams),
        config.swrConfig
    );

    const columns =  [
        {
            Header: "Title",
            accessor: "title",
            className: "col"
        },
        {
            Header: "Slug",
            accessor: "slug",
            className: "col"
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            },
        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div className="btn-group btn-group-sm">
                        <Link
                            className="btn btn-primary"
                            href={`/pages/${row.original.id}`}
                        >
                            <i className="bi bi-eye"></i>
                        </Link>
                        <Link
                            className="btn btn-warning"
                            href={`/pages/${row.original.id}/edit`}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </Link>
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(row.original.id, row.original.title)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                </>
            ),
        },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if(result.isConfirmed){
                setShowLoader(true);
                await pageModel.destroy(id).then((res) => {
                    reloadPageData();
                    helper.sweetalert.toast(`${title} deleted Successfully`);
                });
                setShowLoader(false);
    }});
    };

    return (
        <>
            <Heading title="Pages" showLoader={isLoading || showLoader}>
                {console.log()}
                <Link className="btn btn-primary btn-sm" href="/pages/create">
                <i className="bi bi-plus"/>  Create
                </Link>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Pages Lists</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={pagesData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={pagesData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
